<template>
    <h5>Invoices</h5>
    <div class="table-responsive text-nowrap">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Invoice #</th>
                    <th>Due Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody class="table-border-bottom-0">

                <tr v-if="!invoices || invoices.length === 0">
                    <td colspan="4" style="text-align: center;">No invoice found.</td>
                </tr>

                <tr v-else v-for="item in invoices"  :key="item.invoice_id">
                    <td>
                        <strong>{{ item.invoice_number }}</strong> 
                    </td>
                    <td>{{ item.due_date }}</td>
                    <td>{{ item.balance }}</td>
                    <td>
                        <span :class="['badge', getStatusClass(item.status)]">
                            {{ item.status }}
                        </span>
                    </td>
                </tr>
                
            </tbody>
        </table>
    </div>
</template>

<script>

    export default {
        props: {
            invoices: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            getStatusClass(status) {
                let bg = 'info';
                if(status == 'overdue')
                    bg = 'danger';
                else if(status == 'paid')
                    bg = 'success';

                return 'bg-label-' + bg.toLowerCase();
            }
        }
    };
</script>
